import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from "../../firebase-config";
import { PuffLoader } from "react-spinners";
import { doc, getDoc } from "firebase/firestore";
import { txtdb } from "../../firebase-config"; 

const ProtectedRoute = ({ children }) => {
  const [user, loading, error] = useAuthState(auth);
  
  const [kycStatus, setKycStatus] = useState(null);
  const [kycLoading, setKycLoading] = useState(true);

  const adminUid = "XJOqScE2IegEsiwtZvox7Jonsqi1";

  useEffect(() => {
    const checkKycStatus = async () => {
      // Admin is already excluded here, so no unnecessary database reads!
      if (user && user.uid !== adminUid && user.emailVerified) {
        try {
          const docRef = doc(txtdb, "kycInfo", user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            setKycStatus(docSnap.data().status);
          } else {
            setKycStatus("not_submitted");
          }
        } catch (err) {
          console.error("Error fetching KYC status:", err);
        }
      }
      setKycLoading(false);
    };

    if (!loading) {
      checkKycStatus();
    }
  }, [user, loading, adminUid]);

  if (loading || kycLoading) {
    return (
      <div className="spinner-container">
        <PuffLoader color="#605DBA" size={25} />
      </div>
    );
  }

  if (!user || error) {
    return <Navigate to="/login" replace />;
  }

  // 🟢 THE ADMIN BYPASS
  // If the user is the admin, immediately grant access to the route.
  // This prevents infinite loops and bypasses all email/KYC checks below.
  if (user.uid === adminUid) {
    // Optional: If you still want to force them to the /all-users page 
    // when they try to visit a standard user dashboard:
    if (window.location.pathname !== "/all-users") {
      return <Navigate to="/all-users" replace />;
    }
    return children;
  }

  // 👇 REGULAR USER CHECKS BELOW 👇

  if (!user.emailVerified) {
    return <Navigate to="/verify-account" replace />;
  }

  // 🚫 THE PENDING KYC WALL
  if (kycStatus === "pending") {
    return <Navigate to="/verify-account/pendingApproval" replace />;
  }

  // 🚫 THE MISSING KYC WALL
  if (kycStatus === "not_submitted") {
    return <Navigate to="/verify-account/kyc" replace />; 
  }

  return children;
};

export default ProtectedRoute;